const getFirstLevel =
  (key, defaultVal = []) =>
  (insertId, storeSlice) => {
    const { [key]: byId = {} } = storeSlice;

    const { [insertId]: data = defaultVal } = byId;

    return data;
  };

export const getSecondLevel =
  (key, defaultVal = []) =>
  (insertId2, storeSlice, insertId) => {
    const { [key]: byId = {} } = storeSlice;
    const { [insertId]: byId2 = {} } = byId;
    const { [insertId2]: data = defaultVal } = byId2;

    return data;
  };

export const getDetailErrorMessages = (errorKeys) => (storeSlice) => {
  const messages = errorKeys
    .map((key) => (storeSlice[key] || {}).message)
    .filter((msg) => msg);

  return messages;
};

export const getItems = getFirstLevel("itemsByOrg");

export const getItemsErrorMsg = (storeSlice) => {
  const { itemsError } = storeSlice;
  const { message = "" } = itemsError || {};

  return message;
};

export const getMeta = getFirstLevel("metaByOrg", {
  totalItems: 0,
  totalPages: 1,
});

export const getPagination = getFirstLevel("paginationByOrg", {
  pageNum: 1,
  pageSize: 25,
});

export const getTableQuery = (
  filters,
  orgId,
  pagination,
  sorting,
  selectedInterval
) => {
  const { pageNum, pageSize } = pagination;

  return {
    filters,
    orgId,
    pageNum,
    pageSize,
    sorting,
    selectedInterval,
  };
};

export const getTableFilters = getFirstLevel("tableFiltersByOrg", {});

export const getTableSorting = getFirstLevel("tableSorting", {
  lastSeen: false,
});

export const getTalkers = getSecondLevel("talkersByLogdev");

export const getThreats = getSecondLevel("threatsByLogdev");

export const getWindowsEvts = getSecondLevel("windowsEvtsByLogdev");
